<template>
  <div class="not-found">
    <empty-message>
      <h1>404</h1>
      The page you're looking for doesn't exist.
      <br />
      <router-link to="/events" v-if="isAuthenticated">
        Go to Events
      </router-link>
      <router-link to="/login" v-else> Go to Login </router-link>
    </empty-message>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>

<style lang="scss" scoped>
.not-found {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 200px);
  text-align: center;
}
</style>
